import { Navbar } from '@common/ui/navigation/navbar/navbar';
import { StaticPageTitle } from '../seo/static-page-title';
import { Footer } from '@common/ui/footer/footer';
import { Fragment } from 'react';
import { useSettings } from '@ui/settings/use-settings';
import { BusinessPageContent } from './business-page-content';
import { getBusinessPageAppearanceDefaults } from '@app/admin/settings/business-page-appearance-defaults';
import { PricingTable } from '@common/billing/pricing-table/pricing-table';

import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';

export function BusinessPage() {
  const settings = useSettings();
  const businessPage = settings.businessPage as
    | { appearance: Partial<BusinessPageContent> }
    | undefined;
  const content = getBusinessPageAppearanceDefaults(
    businessPage?.appearance ?? {},
  );

  useEffect(() => {
    AOS.init({
      duration: 1500
    });
  }, []);

  return (

    <Fragment>
      <StaticPageTitle>Business</StaticPageTitle>
      <div>
        <Navbar
          className="sticky top-0 flex-shrink-0"
          menuPosition="contact-us-page"
        />

        <BusinessBanner content={content} />

        <Logos content={content} />

        <WorkFlow content={content} />

        <AddsImage content={content} />

        <CuttingEdge content={content} />

        <Advertisement content={content} />

        <Footer className="container mx-auto flex-shrink-0 px-24" />
      </div>
    </Fragment>

  );
}

interface ContentProps {
  content: BusinessPageContent;
}

function BusinessBanner({ content }: ContentProps) {
  return (
    <>
      <section className='business_banner'>
        <div className='landing-container'>
          <div className='row'>
            <div className='col-xl-8 col-lg-7 mb-4'>
              <div className='baner_contents Business_con' >
                <h1 data-aos="fade-right" dangerouslySetInnerHTML={{__html: content.bannerHeading}} />
                <p data-aos="fade-left">{content.bannerSubtext}</p>
              </div>
              <div className='busiee_img' data-aos="fade-up">
                <img src={content.bannerImage} alt="" />
              </div>
            </div>
            <div className='col-xl-4 col-lg-5 mb-4'>
              <div className='business_shadow' data-aos="fade-down-left">
                <PricingTable
                  selectedCycle="yearly"
                  productIds={
                    content.pricingProductId ? [content.pricingProductId] : undefined
                  }
                  cardColumnClassName="col-12"
                />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}


function Logos({ content }: ContentProps) {
  return (
    <>
      <section className='logo_section'>
        <div className='landing-container'>
          <div className='feature_in'>
            <h3 data-aos="fade-down-right">{content.logosHeading}</h3>
          </div>

          <div className='row justify-content-center pt-sm-4 pt-3'>
            {content.logos.map((logo, index) => (
              <div className='col-lg-2 col-md-3 col-sm-4 col-4 mb-3' key={index}>
                <div className='logo_img' data-aos="zoom-in">
                  <img src={logo.image} alt="" />
                </div>
              </div>
            ))}
          </div>

        </div>
      </section>
    </>
  )
}

interface IconFeatureListProps {
  features: BusinessPageContent['workflowFeatures'];
}
function IconFeatureList({ features }: IconFeatureListProps) {
  return (
    <>
      {features.map((feature, index) => (
        <div className='key_flx' key={index}>
          <div className='key_img'>
            <img src={feature.image} alt="" />
          </div>
          <div className='key_contents'>
            <h2>{feature.title}</h2>
            <p>{feature.description}</p>
          </div>
        </div>
      ))}
    </>
  );
}

function WorkFlow({ content }: ContentProps) {
  return (
    <>
      <section className='workflow_section'>
        <div className='landing-container'>
          <div className='row justify-content-center'>
            <div className='col-lg-7'>
              <div className='workflow_head text-center' data-aos="fade-up">
                <h1>{content.workflowHeading}</h1>
              </div>
            </div>
          </div>
          <div className='row'>
            <div className='col-lg-6 mb-4'>
              <div className='workflow_img' data-aos="fade-up-right">
                <img src={content.workflowImage} alt="" />
              </div>
            </div>
            <div className='col-lg-6 mb-4'>
              <div data-aos="fade-left">
                <IconFeatureList features={content.workflowFeatures} />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}

function AddsImage({ content }: ContentProps) {
  return (
    <>
      <section className='adds_section'>
        <div className='landing-container'>
          <div className='row row_reverse'>
            <div className='col-lg-6 mb-4'>
              <div className='adds_contents' data-aos="fade-right">
                <p>{content.testimonialQuoteLine1}</p>
                <p>{content.testimonialQuoteLine2}</p>
                <p>{content.testimonialAuthor}</p>
                <div className='free_b'>
                  <button type='button'>{content.testimonialButtonLabel}</button>
                </div>
              </div>
            </div>
            <div className='col-lg-6 mb-4'>
              <div className='adds_img' data-aos="fade-up-left">
                <img src={content.testimonialImage} alt="" />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}


function CuttingEdge({ content }: ContentProps) {
  return (
    <>
      <section className='cuttingedge_section'>
        <div className='landing-container'>
          <div className='row justify-content-center'>
            <div className='col-xl-6 col-lg-8'>
              <div className='cutting_head' data-aos="fade-up">
                <h1>{content.cuttingEdgeHeading}</h1>
              </div>
            </div>
          </div>
          <div className='row'>
            <div className='col-lg-6 mb-4'>
              <div className='workflow_img' data-aos="fade-right">
                <img src={content.cuttingEdgeImage} alt="" />
              </div>
            </div>
            <div className='col-lg-6 mb-4'>
              <div data-aos="fade-left">
                <IconFeatureList features={content.cuttingEdgeFeatures} />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}

function Advertisement({ content }: ContentProps) {
  return (
    <>
      <section className='advertisement_section'>
        <div className='landing-container'>
          <div className='row justify-content-center'>
            <div className='col-xl-6 col-lg-8'>
              <div className='adver_head'>
                <h1 data-aos="fade-down">{content.advertisementHeading}</h1>
                <p data-aos="fade-up">{content.advertisementSubtext}</p>
              </div>
            </div>
          </div>
          <div className='row justify-content-center'>
            <div className='col-lg-12 mb-5'>
              <div className='advertisement_img' data-aos="fade-left">
                <img src={content.advertisementImage1} alt="" />
              </div>
            </div>
            <div className='col-lg-10 mb-5'>
              <div className='advertisement_img' data-aos="fade-right">
                <img src={content.advertisementImage2} alt="" />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}
